import { FC } from 'react'

import { AnyAptosWallet } from '@aptos-labs/wallet-adapter-core'
import { ReactComponent as ExternalLink } from 'assets/external-link.svg'
import { ReactComponent as Halborn } from 'assets/halborn.svg'

import { cx } from 'utils/cx'

import s from './s.module.scss'

type Props = {
  isPontem?: boolean
  wallet: AnyAptosWallet
}

const WalletItem: FC<Props> = ({ isPontem = false, wallet }) => {
  return (
    <div className={cx(s.item, isPontem && s.pontemItem)}>
      <img alt="token" className={s.iconWallet} src={wallet.icon} />
      <div className={s.description}>
        <h3>
          {wallet.name.toLowerCase().endsWith(' wallet') || wallet.name.toLowerCase().endsWith('wallet')
            ? wallet.name
            : `${wallet.name} Wallet`}
        </h3>
        {isPontem && (
          <span>
            Audited by <Halborn className={s.halborn} />
          </span>
        )}
      </div>
      {isPontem && (
        <div className={s.recommended}>
          <span>recommended</span>
        </div>
      )}
      {wallet.readyState === 'NotDetected' && !isPontem && (
        <span className={s.install}>
          <ExternalLink />
        </span>
      )}
      {wallet.readyState === 'Installed' && !isPontem && <span className={s.detected}>detected</span>}
    </div>
  )
}

export default WalletItem
